module.exports = __webpack_public_path__ + "static/media/OriginalSurfer-Regular.0c694381.ttf";